import { formatDate } from "../utils";
import type {
  FormData,
  UserData,
  EvaluationType_Option,
} from "../types";

interface PreviewHeaderProps {
  formData: FormData;
  userData: UserData | null;
  evaluationTypes: EvaluationType_Option[];
}

export const PreviewHeader: React.FC<PreviewHeaderProps> = ({
  formData,
  userData,
  evaluationTypes,
}) => {
  const evaluationType = evaluationTypes.find((t) => t.id === formData.type);

  return (
    <div className="header-box border-b-2 border-indigo-700 pb-6 mb-8">
      <div className="text-center mb-6">
        <h1 className="text-2xl font-bold text-indigo-900 mb-2 uppercase">
          {formData.schoolName || "NOME DA ESCOLA"}
        </h1>
        <p className="text-sm text-gray-700">
          Professor(a): {formData.professorName || "Nome do Professor"}
        </p>
        {userData?.institution && (
          <p className="text-xs text-gray-600 mt-1">
            Instituição: {userData.institution}
          </p>
        )}
      </div>

      <div className="grid grid-cols-3 gap-4 text-sm bg-indigo-50 p-4 rounded-lg border border-indigo-200">
        <div>
          <strong className="text-indigo-900">Disciplina:</strong>
          <p className="text-gray-800">{formData.subject}</p>
        </div>
        <div>
          <strong className="text-indigo-900">Turma:</strong>
          <p className="text-gray-800">{formData.class}</p>
        </div>
        <div>
          <strong className="text-indigo-900">Data:</strong>
          <p className="text-gray-800">{formatDate(formData.dueDate)}</p>
        </div>
      </div>

      <div className="mt-4 text-sm border-t border-indigo-200 pt-4">
        <p>
          <strong className="text-indigo-900">Aluno(a):</strong>{" "}
          <span className="border-b border-gray-400 inline-block w-96">
            &nbsp;
          </span>
        </p>
        <p className="mt-2">
          <strong className="text-indigo-900">Nota:</strong>{" "}
          <span className="border-b border-gray-400 inline-block w-24">
            &nbsp;
          </span>
        </p>
      </div>
    </div>
  );
};
